// Vendors
import React from 'react';
import moment from 'moment';

// Components
import { Trans } from '../../../components/common';
import ServiceIconText from '../../../components/common/ServiceIconText/ServiceIconText';
import SummaryCard from '../../../components/common/Cards/SummaryCard/SummaryCard';

// Helpers
import { toSentenceCase } from '../../../lib/helpers';

// PRJ1417943_IntergrationAccelerator - Separated from UnlinkServiceModal for reusability and agency-specific  Props: account, agency, t
const TPWDSummaryCard = ({ account, agency, t }) => (
  <SummaryCard
    key={account.txNumber}
    className="summary-card-tpwd card-flat"
    outlined={false}
    graphic={
      <ServiceIconText
        // isUnlinkVehicleModal={true}
        className="agency-linked-services-item-icon-text"
        type={`boat-plate`}
        text={`TX ${account.txNumber.substring(0, 4) +
          ' ' +
          account.txNumber.substring(4)}`}
      />
    }
    horizontalList={false}
  >
    <div className="vehicle-details vehicle-details-tpwd">
      <div className="vehicle-details-tpwd">
        <SummaryCard.List
          fullWidth
          items={[
            {
              label: <Trans file="Labels" id="assetType" />,
              value: t(`tpwdas_${toSentenceCase(account.assetType || '')}`),
            },
            {
              label: <Trans file="Labels" id="assetMake" />,
              value: account.make,
            },
            {
              label: (
                <Trans
                  file="Labels"
                  id="assetRegistrationExpiry"
                />
              ),
              value: moment(account.expirationDate).format(
                'MM/DD/YYYY'
              ),
            },
          ]}
        />
        <SummaryCard.List
          className={`${agency.agencySlug}`}
          fullWidth
          items={[
            {
              label: (
                <Trans file="Labels" id="assetModelYear" />
              ),
              value: account.modelYear,
            },
            {
              label: <Trans file="Labels" id="assetLength" />,
              value: account.length,
            },
          ]}
        />
      </div>
    </div>
  </SummaryCard>
);

export default TPWDSummaryCard;
